import { useRef, useState, useEffect } from "react";
import useAuth from "../hooks/useAuth";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Login.css";
import axios from "../api/axios";
import { Container } from 'react-bootstrap';
import 'boxicons/css/boxicons.min.css';
const url = "/login";

const Login = () => {
  const { setAuth, persist, setPersist } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();
  // const from = location.state?.from?.pathname || "/dashboard";




  const userRef = useRef();
  const errRef = useRef();

  const [username, setUsername] = useState("");
  const [pwd, setPwd] = useState("");
  const [errMsg, setErrMsg] = useState("");

  useEffect(() => {
    userRef.current.focus();
  }, []);

  useEffect(() => {
    setErrMsg("");
  }, [username, pwd]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        username: username,
        password: pwd,
      };

      var accessToken = null;
      var roles = "";
      var name = "";
      var level_name = "";
      var category = "";
      var level_id = null;

      var parent_name = "";
      var parent_id = "";

      await axios
        .post(url, payload, {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        })
        .then((result) => {
          accessToken = result?.data?.accessToken;
          roles = result?.data?.role;
          name = result?.data?.name;
          level_id = result?.data?.level_id;

          level_name = result?.data?.level_name;
          category = result?.data?.category;

          parent_name = result?.data?.parent_name;
          parent_id = result?.data?.parent_id

        });

      setAuth({
        username,
        roles,
        name,
        level_id,
        accessToken,
        level_name,
        category,

        parent_name,
        parent_id
      });
      setUsername("");
      setPwd("");

      // Conditional redirection based on role
      if (roles === "Arthiksakha") {
        navigate("/ArthiksakhaDashboard", { replace: true });
      }
      else if (roles === "Sthan") {
        if (!category) {
          navigate("/sthan/add/categories", { replace: true });
        } else {
          navigate("/sthanDashboard", { replace: true });
        }
      }

      else if (roles === "Admin") {
        navigate("/dashboard", { replace: true });
      }

    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data) {
        setErrMsg(err.response.data.message);
      } else {
        setErrMsg("Login Failed!");
      }
      errRef.current.focus();
    }
  };

  const togglePersist = () => {
    setPersist((prev) => !prev);
  };

  useEffect(() => {
    localStorage.setItem("persist", persist);
  }, [persist]);

  return (
    <>

      <Container>
        <section className="loginbody">
          <p
            ref={errRef}
            className={errMsg ? "errmsg" : "offscreen"}
            aria-live="assertive"
          >
            {errMsg}
          </p>

          <div className="wrapper logwrap">
            <form onSubmit={handleSubmit}> {/* Add onSubmit handler to trigger login */}

              {/* <h1>LOGIN</h1> */}
              <div className="center-image">

                <img src="/images/newlogowhite.png" width="50%" className='log-img' />
              </div>

              <div className="input-box arthik_input-box">

                <input
                  type="text"
                  id="username"
                  placeholder="Username"
                  autoComplete="off"
                  ref={userRef} // Attach the ref to this input

                  onChange={(e) => setUsername(e.target.value)}
                  value={username}
                  required
                />
                <i className="bx bxs-user icon"></i>
              </div>


              <div className="input-box arthik_input-box">

                <input
                  type="password"
                  id="password"
                  autoComplete="off"
                  placeholder="Password"

                  onChange={(e) => setPwd(e.target.value)}
                  value={pwd}
                  required
                />
                <i className="bx bxs-lock-alt"></i>
              </div>
              <div className="persistCheck remember-forget">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    id="persist"
                    onChange={togglePersist}
                    checked={persist}
                  />
                  <span className="newspan">Trust This Device</span>
                </label>
              </div>


              <button type="submit" className="btn">Sign In</button>

              <p className="arthik_reg">Not a Member ? <Link to="/register" className="arthik_a"> Sign Up</Link></p>

            </form>
          </div>
        </section>
      </Container>

    </>
  );
};

export default Login;
